<script>
import ValidationMixin from "@/mixins/validation.mixin";
import { OrdersMixin } from "@/views/orders/orders.mixin";
import { mapActions } from "pinia";
import { useSnackbarStore } from "@/store/snackbar.store";
import CheckInDialog from "@/views/trips/components/dialogs/CheckInDialog.vue";
import { RouteStatus } from "@/data/trip.js";

export default {
  name: "CheckInAction",
  components: { CheckInDialog },
  mixins: [ValidationMixin, OrdersMixin],
  inheritAttrs: false,
  props: {
    trip: Object,
    route: Object,
    stop: Object,
  },
  emits: ["checkedIn"],
  data() {
    return {
      showDialog: false,
      loading: false,
      checkInData: {},
    };
  },
  computed: {
    isPlanned() {
      return this.route.status === RouteStatus.planned;
    },
    btnClass() {
      if (this.isPlanned) {
        return "bg-grey-lighten-2 text-grey";
      } else {
        return "bg-primary text-white";
      }
    },
  },
  watch: {
    async showDialog(value) {
      if (value) {
        this.checkInData.timezone = this.stop.facility.timezone;
        const date = this.$dayjs().tz(this.checkInData.timezone);
        this.checkInData.date = date.format("YYYY-MM-DD");
        this.checkInData.time = date.format("HH:mm");
      }
    },
  },
  methods: {
    ...mapActions(useSnackbarStore, ["showSnackbarError"]),
    showCheckInConfirmation() {
      this.showDialog = true;
    },
  },
};
</script>

<template>
  <v-tooltip :disabled="!isPlanned" location="top">
    <template #activator="{ props: tooltipProps }">
      <div v-bind="tooltipProps">
        <v-btn :class="btnClass" block v-bind="$attrs" variant="flat" @click="showCheckInConfirmation"> Check in</v-btn>
      </div>
    </template>

    This action is not available because the route is not active
  </v-tooltip>
  <check-in-dialog
    v-model="showDialog"
    :route="route"
    :stop="stop"
    :trip-id="trip.id"
    @checked-in="$emit('checkedIn')"
  />
</template>

<style lang="scss" scoped></style>
